import httpClient from './httpClient'

const END_POINT_ZENDESK_SSO = '/zendesk/sso/'

// Returns { url } — a Zendesk /access/jwt SSO URL logging the current user in.
// returnTo (optional): Zendesk page to land on after login (backend-validated)
const getZendeskSsoUrl = (returnTo) => httpClient.get(END_POINT_ZENDESK_SSO, { params: returnTo ? { return_to: returnTo } : undefined })

export { getZendeskSsoUrl }
